'use client';

import { ReportMetadata } from '@/lib/api';

interface ReportCardProps {
  report: ReportMetadata;
  onSelect: (reportId: string) => void;
}

export default function ReportCard({ report, onSelect }: ReportCardProps) {
  return (
    <button
      onClick={() => onSelect(report.id)}
      className="w-full p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow text-left border border-gray-200 hover:border-blue-500"
    >
      <h3 className="text-xl font-semibold text-gray-900 mb-2">{report.name}</h3>
      <p className="text-gray-600 mb-4">{report.description}</p>
      <div className="flex flex-wrap gap-2">
        {report.supportsDateRange && (
          <span className="px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded">
            Date Range
          </span>
        )}
        {report.supportsCustomerId && (
          <span className="px-2 py-1 bg-green-100 text-green-800 text-xs rounded">
            Customer Filter
          </span>
        )}
        {report.supportsAgentId && (
          <span className="px-2 py-1 bg-purple-100 text-purple-800 text-xs rounded">
            Agent Filter
          </span>
        )}
      </div>
    </button>
  );
}

